import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Agent, CashFloat, AuthUser } from '../types/agent.types';

interface AgentState {
  agent: Agent | null;
  user: AuthUser | null;  // 🆕 Datos de usuario con multi-rol
  cashFloat: CashFloat | null;
  isAuthenticated: boolean;
  accessToken: string | null;

  setAgent: (agent: Agent) => void;
  setUser: (user: AuthUser) => void;  // 🆕 Set user data
  setCashFloat: (cashFloat: CashFloat) => void;
  setAuth: (token: string, user: AuthUser) => void;  // Cambio: recibe user en lugar de agent
  logout: () => void;
  updateFloatBalance: (newBalance: number) => void;
}

export const useAgentStore = create<AgentState>()(
  persist(
    (set) => ({
      agent: null,
      user: null,
      cashFloat: null,
      isAuthenticated: false,
      accessToken: null,

      setAgent: (agent) => set({ agent }),

      setUser: (user) => set({ user }),

      setCashFloat: (cashFloat) => set({ cashFloat }),

      setAuth: (token, user) => {
        localStorage.setItem('agentAccessToken', token);
        set({ accessToken: token, user, isAuthenticated: true });
      },

      logout: () => {
        localStorage.removeItem('agentAccessToken');
        set({
          agent: null,
          user: null,
          cashFloat: null,
          isAuthenticated: false,
          accessToken: null,
        });
      },

      updateFloatBalance: (newBalance) =>
        set((state) => ({
          cashFloat: state.cashFloat
            ? { ...state.cashFloat, currentBalance: newBalance }
            : null,
        })),
    }),
    {
      name: 'agent-storage',
      partialize: (state) => ({
        agent: state.agent,
        user: state.user,
        accessToken: state.accessToken,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
